import React from 'react';
import { MapContainer, TileLayer, Marker, Circle, Popup } from 'react-leaflet';
import L from 'leaflet';
import { MapPin } from 'lucide-react';
import { FadeIn } from './Animations';
// Custom marker icon using HTML to avoid missing image issues in React Leaflet
const customIcon = new L.DivIcon({
  className: 'custom-leaflet-icon',
  html: `<div style="background-color: #DC2626; width: 16px; height: 16px; border-radius: 50%; border: 3px solid white; box-shadow: 0 0 4px rgba(0,0,0,0.5);"></div>`,
  iconSize: [16, 16],
  iconAnchor: [8, 8]
});
export const ServiceArea = () => {
  const center: [number, number] = [36.7378, -119.7871]; // Fresno
  const cities = [{
    name: 'Fresno',
    pos: [36.7378, -119.7871] as [number, number]
  }, {
    name: 'Clovis',
    pos: [36.8252, -119.7029] as [number, number]
  }, {
    name: 'Madera',
    pos: [36.9613, -120.0607] as [number, number]
  }, {
    name: 'Selma',
    pos: [36.5708, -119.6121] as [number, number]
  }, {
    name: 'Sanger',
    pos: [36.708, -119.5559] as [number, number]
  }, {
    name: 'Reedley',
    pos: [36.5963, -119.4504] as [number, number]
  }, {
    name: 'Kerman',
    pos: [36.7236, -120.0601] as [number, number]
  }];
  return <section id="areas" className="py-16 bg-brand-gray border-t border-zinc-200" data-id="element-483">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-484">
        <FadeIn className="text-center mb-10" data-id="element-485">
          <h2 className="font-oswald text-3xl md:text-4xl font-bold uppercase text-brand-black mb-4" data-id="element-486">
            We Serve the Entire Central Valley
          </h2>
          <p className="text-zinc-600 text-lg max-w-2xl mx-auto" data-id="element-487">
            From Fresno to Madera and everywhere in between. If you're in the
            Central Valley, we've got you covered.
          </p>
        </FadeIn>

        <div className="grid lg:grid-cols-3 gap-8 items-start" data-id="element-488">
          <FadeIn className="lg:col-span-2 h-[400px] md:h-[500px] rounded-sm overflow-hidden border-4 border-white shadow-md z-0 relative" data-id="element-489">
            <MapContainer center={center} zoom={9} scrollWheelZoom={false} style={{
            height: '100%',
            width: '100%',
            zIndex: 1
          }} data-id="element-490">
              <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-491" />
              <Circle center={center} radius={45000} pathOptions={{
              color: '#DC2626',
              fillColor: '#DC2626',
              fillOpacity: 0.1,
              weight: 2
            }} data-id="element-492" />
              {cities.map(city => <Marker key={city.name} position={city.pos} icon={customIcon} data-id="element-493">
                  <Popup className="font-sans font-bold" data-id="element-494">{city.name}</Popup>
                </Marker>)}
            </MapContainer>
          </FadeIn>

          <FadeIn delay={0.2} className="bg-white p-8 rounded-sm shadow-sm border border-zinc-200" data-id="element-495">
            <div className="flex items-center gap-3 mb-6" data-id="element-496">
              <MapPin className="w-6 h-6 text-brand-red" data-id="element-497" />
              <h3 className="font-oswald text-2xl font-bold uppercase text-brand-black" data-id="element-498">
                Service Areas
              </h3>
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-499">
              {cities.map(city => <span key={city.name} className="bg-brand-gray text-brand-black px-4 py-2 rounded-sm text-sm font-semibold border border-zinc-200" data-id="element-500">
                  {city.name}
                </span>)}
              <span className="bg-brand-red text-white px-4 py-2 rounded-sm text-sm font-bold" data-id="element-501">
                + Surrounding Areas
              </span>
            </div>
            <div className="mt-8 pt-8 border-t border-zinc-100" data-id="element-502">
              <p className="font-oswald font-bold uppercase text-brand-black mb-2" data-id="element-503">
                Not sure if we cover you?
              </p>
              <a href="tel:+15597709442" className="text-brand-red font-bold hover:underline" data-id="element-504">
                Call (559) 770-9442 to ask
              </a>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
};